import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { EntidadDto } from '../dto/expediente/entidad.dto';
import { TipoProcesoDto } from '../dto/expediente/tipo-proceso.dto';
import { EstadoExpedienteDto } from '../dto/expediente/estado-expediente.dto';
import { environment } from '../../environments/environment';
import { TipoAnexoDto } from '../dto/expediente/tipo-anexos.dto';
import { PaisDto } from '../dto/expediente/pais.dto';
import { DepartmentoDto } from '../dto/expediente/departmento.dto';
import { MunicipioDto } from '../dto/expediente/municipio.dto';
import { TipoDocumentoDto } from '../dto/expediente/tipo-documento-dto.dto';
import { TipoPersonaDto } from '../dto/expediente/tipo-persona-dto.dto';
import { ClaseSolicitudDto } from '../dto/expediente/clase-solicitud-dto.dto';
import { AsuntoSolicitudDocumentoDto } from '../dto/expediente/asunto-solicitud-documento.dto';
import { FormFieldOption } from '../dto/util/form-field';
import { ListaValorDto } from '../dto/expediente/lista-valor.dto';
import { AsuntoTramiteDto } from '../dto/expediente/asuntoTramite.dto';
import { ListaDTO } from '../modules/util/modal-datos/dtos/lista-DTO';
import { EntidadFinanciera } from '../modules/util/modal-datos/dtos/entidad-financiera-DTO';
import { EstadosExpedienteDto } from '../dto/expediente/estados-expediente-entidad.dto';

@Injectable({
  providedIn: 'root',
})
export class ListasService {
  private apiUrl = `${environment.apiUrl}/lista`;
  private listaEstado = `${environment.apiUrl}/estado-expediente`;
  private apiUrlPublico = `${environment.apiUrl}/creacion-empresa/listavalor`;


  constructor(private http: HttpClient) {}

  getTipoDocumento(): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(`${this.apiUrl}/tipo-documento`);
  }

  getTipoDocumentoAcronimo(acronimo: String): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(`${this.apiUrl}/tiposdocumento/acronimo/`+acronimo);
  }

  getEntidades(): Observable<EntidadDto[]> {
    return this.http.get<EntidadDto[]>(`${this.apiUrl}/entidades`);
  }

  getTiposProceso(idEntidad: number): Observable<TipoProcesoDto[]> {
    let queryParams = {};
    if (idEntidad != 0) {
      queryParams = {
        entidad: idEntidad,
      };
    }
    return this.http.get<TipoProcesoDto[]>(`${this.apiUrl}/tipos-proceso`, {
      params: queryParams,
    });
  }

  getEstadosExpediente(idEntidad: number): Observable<EstadoExpedienteDto[]> {
    let queryParams = {};
    if (idEntidad != 0) {
      queryParams = {
        entidad: idEntidad,
      };
    }
    return this.http.get<EstadoExpedienteDto[]>(
      `${this.apiUrl}/estados-expediente`,
      {
        params: queryParams,
      }
    );
  }

  getTipoAnexos(idEntidad: number): Observable<TipoAnexoDto[]> {
    return this.http.get<TipoAnexoDto[]>(
      `${this.apiUrl}/tipo-anexos/${idEntidad}`
    );
  }

  getCountryList(): Observable<PaisDto[]> {
    return this.http.get<PaisDto[]>(`${this.apiUrl}/paises`);
  }

  getDepartmentList(idCountry: number): Observable<DepartmentoDto[]> {
    return this.http.get<DepartmentoDto[]>(
      `${this.apiUrl}/departamentos/${idCountry}`
    );
  }

  getMunicipalityList(idDepartment: number): Observable<MunicipioDto[]> {
    return this.http.get<MunicipioDto[]>(
      `${this.apiUrl}/municipios/${idDepartment}`
    );
  }

  getDocumentTypeList(): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(`${this.apiUrl}/tiposdocumento`);
  }

  getDocumentTypeListByPersonType(
    personTypeId: string,
    entidadId: number
  ): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(
      `${this.apiUrl}/tiposdocumentoportipopersona/${personTypeId}/${entidadId}`
    );
  }

  getDocumentTypeListCreateUsers(): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(
      `${this.apiUrl}/tiposdocumentocrearusuario`
    );
  }

  getDocumentTypePersonaLegalList(): Observable<TipoDocumentoDto[]> {
    return this.http.get<TipoDocumentoDto[]>(
      `${this.apiUrl}/tiposdocumentomayoredad`
    );
  }

  getTipoDePersonaList(): Observable<TipoPersonaDto[]> {
    return this.http.get<TipoPersonaDto[]>(`${this.apiUrl}/tipospersona`);
  }

  getRequestClassList(): Observable<ClaseSolicitudDto[]> {
    return this.http.get<ClaseSolicitudDto[]>(`${this.apiUrl}/clasessolicitud`);
  }

  getAsuntoTramiteList(): Observable<AsuntoTramiteDto[]> {
    return this.http.get<AsuntoTramiteDto[]>(`${this.apiUrl}/asuntostramite`);
  }

  getListaValor(nombreLista: string): Observable<FormFieldOption[]> {
    return this.http
      .get<ListaValorDto[]>(`${this.apiUrl}/listavalor/${nombreLista}`)
      .pipe(
        map(response =>
          response.map(item => ({
            Id: item.Id,
            Nombre: item.Valor,
          }))
        )
      );
  }

  listaValor(endpoint: string): Observable<ListaValorDto[]> {
    return this.http
      .get<ListaValorDto[]>(`${this.apiUrl}/listavalor/${endpoint}`)
      .pipe();
  }

  listaValorPublico(endpoint: string): Observable<ListaValorDto[]> {
    return this.http
      .get<ListaValorDto[]>(`${this.apiUrlPublico}/${endpoint}`)
      .pipe();
  }

  getAsuntoSolicitudDocumentosList(): Observable<
    AsuntoSolicitudDocumentoDto[]
  > {
    return this.http.get<AsuntoSolicitudDocumentoDto[]>(
      `${this.apiUrl}/listavalor/Asunto_Solicitud_Documentos`
    );
  }

  getGenero(): Observable<ListaDTO[]> {
    return this.http.get<ListaDTO[]>(`${this.apiUrl}/listavalor/Genero`).pipe();
  }

  getDemandados(): Observable<EntidadFinanciera[]> {
    return this.http.get<EntidadFinanciera[]>(`${this.apiUrl}/entidadesVigiladasSSF`).pipe();
  }

  getEstadoExpedienteByIdEntidad(idEntidad: number): Observable<EstadosExpedienteDto[]>{
    return this.http.get<EstadosExpedienteDto[]>(`${this.listaEstado}/estados/${idEntidad}`).pipe();
  }
}
